import { render, staticRenderFns } from "./TableManageMinusPoint.vue?vue&type=template&id=db89e842"
import script from "./TableManageMinusPoint.vue?vue&type=script&lang=js"
export * from "./TableManageMinusPoint.vue?vue&type=script&lang=js"
import style0 from "./TableManageMinusPoint.vue?vue&type=style&index=0&id=db89e842&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports